// extracted by mini-css-extract-plugin
export default {"Button":"IconButton_Button__lUkTt"};